import { useStore as s } from '../../hooks/use-store.js';
import { useIsoMorphicEffect as u } from '../use-iso-morphic-effect.js';
import { overflows as t } from './overflow-store.js';
function a(r, e) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => ({
    containers: []
  });
  let f = s(t),
    o = e ? f.get(e) : void 0,
    i = o ? o.count > 0 : !1;
  return u(() => {
    if (!(!e || !r)) return t.dispatch("PUSH", e, n), () => t.dispatch("POP", e, n);
  }, [r, e]), i;
}
export { a as useDocumentOverflowLockedEffect };